<template>
  <div class="container">
    <div class="text-with-image-cascade">
      <text-with-image-inline
        v-for="(item, index) in content"
        :title_tag="item.title_tag"
        :title="item.title"
        :sub_title="item.sub_title"
        :content="item.content"
        :lazy_img_src="item.lazy_img_src"
        :img_src="item.img_src"
        :key="`image-inline_${index}-${uid}`"
        class="text-with-image-cascade__item"
      />
    </div>
  </div>
</template>

<script>
import TextWithImageInline from "../parts/builder/TextWithImageInline.vue";

export default {
  name: "TextWithImageCascade",
  components: {
    TextWithImageInline
  },
  props: {
    /**props**/
    content: {
      type: Array,
      default: () => [],
      admin_type: 'array',
      array_values: {
        img_src: {
          type: String,
          default: '',
          admin_type: 'image',
        },
        lazy_img_src: {
          type: String,
          default: '',
          admin_type: 'image',
        },
        title: {
          type: String,
          default: '',
          admin_type: 'input',
        },
        sub_title: {
          type: String,
          default: '',
          admin_type: 'input',
        },
        title_tag: {
          type: String,
          default: 'h1',
          admin_type: 'select',
          admin_data_values: [
            'h1', 'h2', 'h3', 'h4', 'h5', 'h6'
          ],
        },
        content: {
          type: String,
          default: '',
          required: true,
          admin_type: 'editor',
        },
      }
    }
    /**props**/
  },
  computed: {
    uid() {
      return this._uid
    },
  }
}
</script>
